import { InternalAxiosRequestConfig } from 'axios'
import { logInterReq } from './interseptors/logInterReq'
import { spTraceInterReq } from './interseptors/spTraceInterReq'

export const comboInterceptorReqNoAuth = async (
    request: InternalAxiosRequestConfig
) => {
    request = spTraceInterReq(request)
    request = logInterReq(request)
    return request
}
